import { FETCH_CONNECTED_CUSTOMERS_FAILURE, FETCH_CONNECTED_CUSTOMERS_REQUESTED, FETCH_CONNECTED_CUSTOMERS_SUCCESS } from "../actions/connected-customers-action-types";

const initialState = {
  fetchConnectedCustomersStatus: "pending",
  connectedCustomers: [],
};

export default function connectedCustomers(state = initialState, {
  payload, type,
}) {
  switch (type) {
    case FETCH_CONNECTED_CUSTOMERS_REQUESTED:
      return {
        ...state,
        fetchConnectedCustomersStatus: "requested",
      };
    case FETCH_CONNECTED_CUSTOMERS_FAILURE:
      return {
        ...state,
        fetchConnectedCustomersStatus: "failure",
      };
    case FETCH_CONNECTED_CUSTOMERS_SUCCESS:
      return {
        ...state,
        fetchConnectedCustomersStatus: "success",
        connectedCustomers: payload?.users?.map((element, index) => ({
          ...element,
          id: index,
        })),
      };
    default:
      return state;
  }
}
